import { msg } from "@lingui/core/macro";

export const uniqueVehiclesOnSettingRuleMessages = {
	name: msg({ message: "Unique Vehicles per Setting" }),
	description: msg({ message: "Permit must not have duplicated plates within this setting" }),
	errors: {
		duplicatePlates: msg({ message: "Permit contains duplicate plates: ({plates})" }),
	},
} as const;
